module.exports = __webpack_public_path__ + "static/2-9baa663b158429473c2327654968a613.jpg";